import apiBase from "../../api/axios";

/**
 * Configuración global de cantidad de talentos (positivos/negativos)
 */

export const getCantidadTalentosGlobalService = async () => {
  const response = await apiBase.get("v1/talentos-global/cantidad-talentos/");
  return response.data;
};

export const putCantidadTalentosGlobalService = async (payload) => {
  const response = await apiBase.put(
    "v1/talentos-global/cantidad-talentos/auto/",
    payload
  );
  return response.data;
};

/**
 * Configuración por plantel de cantidad de talentos (positivos/negativos)
 */

export const getCantidadTalentosPlantelService = async (plantelId) => {
  const response = await apiBase.get(
    `v1/talentos-plantel/cantidad-talentos/plantel/${plantelId}/`
  );
  return response.data;
};

export const putCantidadTalentosPlantelService = async (plantelId, payload) => {
  const response = await apiBase.put(
    `v1/talentos-plantel/cantidad-talentos/plantel/${plantelId}/`,
    payload
  );
  return response.data;
};
